import React, { Component } from 'react';
import PropTypes from 'prop-types';

import ReactGuestPicker from '@homeaway/react-guest-picker';
import GuestPickerIcon from '@homeaway/react-searchbox-lite/lib/transpiled/components/GuestPickerIcon';

import './GuestPicker.less';
const CNAME = 'ModalGuestPicker';


class GuestPicker extends Component {
  static propTypes = {
    guests: PropTypes.shape({
      adultsCount: PropTypes.number,
      childrenCount: PropTypes.number,
      petIncluded: PropTypes.bool
    }).isRequired,
    onSelectorChange: PropTypes.func.isRequired,
    labels: PropTypes.shape({}).isRequired
  };

  static defaultProps = {
    guests: {
      adultsCount: 0,
      childrenCount: 0,
      petIncluded: false
    },
    consolidateInputs: false
  };

  getGuestLabel = (numGuests, pet) => {
    const labels = this.props.labels;
    let petString = pet ? `, ${labels.pets}` : '';
    switch (numGuests) {
    case 0:
      return '';

    case 1:
      return `1 ${labels.guest || labels.guests}${petString}`;

    default:
      return `${numGuests} ${labels.guests}${petString}`;
    }
  };


  render() {
    const { labels, guests: { adultsCount, childrenCount, petIncluded }, onSelectorChange, onGuestPickerClose } = this.props;
    const adultsLabel = adultsCount !== 1 ? `${adultsCount} ${labels.adults}` : `${adultsCount} ${labels.adult}`;
    const childrenLabel = childrenCount !== 1 ? `${childrenCount} ${labels.children}` : `${childrenCount} ${labels.child}`;
    const formSuffixElement = petIncluded ? labels.petMessage : '';


    return (
      <ReactGuestPicker
        modalTitle = {labels.modalGuestPickerTitle}
        label={labels.label}
        name={'Guests'}
        guestLabel={this.getGuestLabel(adultsCount + childrenCount, petIncluded)}

        adultsCount = {adultsCount}
        adultsLabel={adultsLabel}
        childrenCount = {childrenCount}
        childrenLabel={childrenLabel}

        showPetOption
        petLabel={labels.pets}
        petYesLabel={labels.yesBtn}
        petNoLabel={labels.noBtn}
        petIncluded = {petIncluded}
        formSuffixElement = {formSuffixElement}

        showContinue
        continueButtonLabel={labels.applyBtn}
        clearButtonLabel= {''}
        onClose={onGuestPickerClose}
        onChange={onSelectorChange}
        className={CNAME}

        inputIcon = {<GuestPickerIcon />}
      />
    );
  }
}

export default GuestPicker;



// WEBPACK FOOTER //
// ./src/universal/components/Trending/GuestPicker/GuestPicker.js